"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M3 8a1 1 0 011-1h5a1 1 0 010 2H6.414l5.293 5.293a1 1 0 11-1.414 1.414L5 10.414V13a1 1 0 01-2 0V8z", "M20 18a1 1 0 01-1 1H1a1 1 0 01-1-1V2c0-.5.4-1 1-1h18a1 1 0 011 1v16zm-2-1V6H2v11h16z"];
//# sourceMappingURL=th-virtual.js.map